import { call, put, takeLatest } from 'redux-saga/effects';
import HeroCommerceApi from 'api-services/HeroCommerceApi';
import { isSuccessResponse } from 'api-services/types/guards';
import { checkUserHelper } from '../utils/helperSagas';
import { PAYMENT_UPDATE } from './actionTypes';
import { paymentUpdateDone, paymentUpdateError } from './actionCreators';
import { getUserStatus } from '../userLogin/actionCreators';
import { logout } from '../auth/actionCreators';
export function* paymentUpdate(constAccessParams, action) {
    // Check public API access token
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroCommerceApi.paymentUpdate, newAccessParams, action.data);
    if (isSuccessResponse(result)) {
        yield put(paymentUpdateDone());
        yield put(getUserStatus());
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(paymentUpdateError(result.msg));
    }
}
export function* watchPaymentUpdateCalls(constAccessParams) {
    yield takeLatest(PAYMENT_UPDATE, paymentUpdate, constAccessParams);
}
//# sourceMappingURL=saga.js.map